import { render } from "./Product.vue?vue&type=template&id=f588f6cc"
const script = {}

import exportComponent from "/Users/david/Desktop/projects/ConexionCreativa/rg-business/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__